<template>
  <div class="microbiology-timeline">
    <div class="timeline-header">
      <div class="progress-track">
        <div
          class="progress-fill"
          :style="{ width: getProgressPercentage() + '%' }"
        ></div>
      </div>
    </div>

    <div class="timeline-steps">
      <div
        v-for="(step, index) in progressSteps"
        :key="index"
        class="timeline-step"
        :class="getStepClass(step)"
      >
        <div class="step-marker">
          <div class="step-circle"></div>
        </div>

        <div class="step-content">
          <div class="step-title">{{ step.step }}</div>
          <div class="box-date">
            <div class="step-year">{{ step.year }}</div>
            <div class="step-date">{{ step.date }}</div>
            <div class="step-time">{{ step.time }}</div>
          </div>
          <div class="step-description">{{ step.description }}</div>
          <div
            v-if="step.subDescription"
            class="step-subdescription"
          >
            {{ step.subDescription }}
          </div>
          <div
            v-if="step.additionalInfo"
            class="step-additional"
          >
            {{ step.additionalInfo }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MicrobiologyProgressBar',
  props: {
    progressSteps: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    getStepClass(step) {
      if (step.step.includes('Parcial')) return 'step-partial'
      if (step.status === 'completed') return 'step-completed'
      if (step.status === 'final') return 'step-final'
      return 'step-pending'
    },

    getProgressPercentage() {
      if (!this.progressSteps || this.progressSteps.length === 0) return 0

      const completedSteps = this.progressSteps.filter(
        step => step.status === 'completed' || step.status === 'final'
      ).length

      return Math.round((completedSteps / this.progressSteps.length) * 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.microbiology-timeline {
  width: 100%;
  font-family: 'Exo 2', sans-serif;
  margin-top: 88px;

  .timeline-header {
    .progress-track {
      position: relative;
      height: 6px;
      background-color: #e6e6e6;
      border-radius: 3px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: linear-gradient(
          90deg,
          #ef9a4b 0%,
          #ee5c53 35%,
          #ec2072 70%,
          #7f1a54 100%
        );
        border-radius: 3px;
        transition: width 0.5s ease;
      }
    }
  }

  .timeline-steps {
    display: flex;
    position: relative;

    .timeline-step {
      flex: 1;
      display: flex;
      align-items: flex-start;
      padding-right: 20px;
      position: relative;

      &:last-child {
        padding-right: 0;
      }

      .step-marker {
        position: absolute;
        top: -17px;
        left: -5px;
        border: 5px solid #ffffff;
        border-radius: 50%;

        .step-circle {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          background-color: #e6e6e6;
          border: 3px solid #fff;
          box-shadow: 0 0 0 2px #e6e6e6;
          transition: all 0.3s ease;
        }
      }

      .step-content {
        flex: 1;
        padding-left: 16px;
        border-left: 2px solid #ccc;
        margin-left: 8px;
        margin-top: 13px;
        height: calc(100% - 12px);

        .box-date {
          position: absolute;
          top: -82px;
          left: -8px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .step-year,
          .step-date,
          .step-time {
            color: #7a7a7a;
            font-weight: 700;
          }

          .step-year {
            font-size: 11px;
          }

          .step-date {
            font-size: 14px;
            margin-bottom: 2px;
          }

          .step-time {
            font-size: 12px;
            color: #363636;
            margin-bottom: 6px;
          }
        }

        .step-title {
          font-size: 12px;
          font-weight: 700;
          color: #303030;
          margin-bottom: 2px;
        }

        .step-description {
          font-size: 11px;
          color: #7a7a7a;
          text-transform: uppercase;
          margin-bottom: 2px;
        }

        .step-subdescription {
          font-size: 12px;
          color: #303030;
          margin-bottom: 2px;
        }

        .step-additional {
          font-size: 11px;
          color: #ec2072;
          text-decoration: underline;
        }
      }

      &.step-completed {
        .step-marker .step-circle {
          background: #f78e26;
          box-shadow: 0 0 0 2px #f78e26;
        }
      }

      &.step-partial {
        .step-marker .step-circle {
          background: #f05253;
          box-shadow: 0 0 0 2px #f05253;
        }

        .step-content .step-title {
          color: #f05253;
        }
      }

      &.step-final {
        .step-marker .step-circle {
          background: #7f1a54;
          box-shadow: 0 0 0 2px #7f1a54;
        }

        .step-content .step-title {
          color: #7f1a54;
        }
      }
    }
  }
}
</style>
